export const getEnergies = (state) => state.energies.all
